import { ComponentService } from "../Services/Axios/Api";

class SimpleNewsTicker {
    data = {};
    constructor() {
        this.data = {
            id: '7',
            ComponentName: 'SimpleNewsTicker',
            isEnabled: true,
            title: "Latest Updates",
            newsItems: [
                "Welcome to our platform!",
                "New features coming soon!",
                "Stay tuned for exciting updates!"
            ],
            style: {
                newsTickerContainer: {
                    backgroundColor: "#282c34"
                },
                newsItem: {
                    color: "#ffffff"
                },
                NewsTickerTitle: {
                    backgroundColor: "#61dafb",
                    color: "#282c34"
                }
            }
        };
    }

    // Id   
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Enabled Status
    getIsEnabled() { return this.data.isEnabled; }
    setIsEnabled(isEnabled) { this.data.isEnabled = isEnabled; }

    // Title
    getTitle() { return this.data.title; }
    setTitle(title) { this.data.title = title; }

    // News Items
    getNewsItems() { return [...this.data.newsItems]; }
    setNewsItems(newsItems) { this.data.newsItems = [...newsItems]; }
    
    addNewsItem(item) {
        this.data.newsItems = [...this.data.newsItems, item];
    }

    removeNewsItem(index) {
        if (index >= 0 && index < this.data.newsItems.length) {
            this.data.newsItems = this.data.newsItems.filter((_, i) => i !== index);
        }
    }

    updateNewsItem(index, newItem) {
        if (index >= 0 && index < this.data.newsItems.length) {
            this.data.newsItems = this.data.newsItems.map((item, i) => 
                i === index ? newItem : item
            );
        }
    }

    // Style
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }

    getBackgroundColor() { return this.data.style.newsTickerContainer.backgroundColor; }
    setBackgroundColor(color) { this.data.style.newsTickerContainer.backgroundColor = color; }

    getTextColor() { return this.data.style.newsItem.color; }
    setTextColor(color) { this.data.style.newsItem.color = color; }

    // NewsTickerTitle Style
    getTitleBackgroundColor() { return this.data.style.NewsTickerTitle.backgroundColor; }
    setTitleBackgroundColor(color) { this.data.style.NewsTickerTitle.backgroundColor = color; }

    getTitleColor() { return this.data.style.NewsTickerTitle.color; }
    setTitleColor(color) { this.data.style.NewsTickerTitle.color = color; }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Methods
    async load(Language) {
        try {
            const response = await ComponentService.getStaticComponent(this.data.ComponentName, Language, true);
            const data = JSON.parse(response?.data);
            this.setData(data);
            this.setId(response?.id);
            this.setIsEnabled(data.isEnabled);
            this.setTitle(data.title);
            this.setNewsItems(data.newsItems);
            this.setStyle(data.style);
            return JSON.parse(response?.data);
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}

export const createSimpleNewsTickerInstance = () => new SimpleNewsTicker(); 